import { FunctionalComponent, h, VNode } from '@stencil/core';
import { JSXBase } from '@stencil/core/internal';
import { marked } from 'marked';
import { renderer } from './MarkdownRenderer';
import HTMLAttributes = JSXBase.HTMLAttributes;

type Props = HTMLAttributes<HTMLDivElement>;

marked.use({
  renderer,
  mangled: false,
  headerIds: false
});

export function parse(markup: VNode | string): string {
  return marked.parse(String(markup));
}

// https://marked.js.org/using_advanced#extensions
export const Markup: FunctionalComponent<Props> = (
  props,
  [markup],
) => {
  const html = parse(markup);
  return <div {...props} innerHTML={html} />;
};
